import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../services/authentication.service';
import { StorageManagerService } from '../services/storage-manager.service';

// This class is used to create http header for all api calls
export class HttpHelper {
    apiResult: any;

    constructor(private http: HttpClient, private authService: AuthenticationService, private storage: StorageManagerService) {
    }

    // Create helper for api calls
    createHttpHeaders(applicationVariantName: string = ''): HttpHeaders {
        let headers: HttpHeaders;
        const currentCustomer = !this.storage.read('currentCustomer') || typeof this.storage.read('currentCustomer') === 'object' ? this.storage.read('currentCustomer') : JSON.parse(this.storage.read('currentCustomer'));
        const currentContactId = sessionStorage['currentContactId'] !== undefined ? sessionStorage['currentContactId'] : '';
        const currentCompanyId = sessionStorage['currentCompanyId'] !== undefined ? sessionStorage['currentCompanyId'] : '';
        const currentCompanyRevisionId = sessionStorage['currentCompanyRevisionId'] !== undefined ? sessionStorage['currentCompanyRevisionId'] : '';
        const authData = this.authService.getAuthData();

        // If the applicationVariant name is not supplied, default to authData.applicationVariantName.
        applicationVariantName = !applicationVariantName ? authData.applicationVariantName : applicationVariantName

        headers = new HttpHeaders({
            'content-Type': 'application/json',
            accept: 'text/plain',
            'customerGuid': currentCustomer.customerGuid,
            'applicationVariantId': authData.applicationVariantId ? authData.applicationVariantId.toString() : '',
            'applicationName': authData.applicationName ? authData.applicationName.toString() : '',
            'applicationVariantName': applicationVariantName,
            'authorization': this.authService.getBearerToken()
        });

        if (currentContactId !== '') {
            headers = headers.set('contactId', currentContactId);
        } else if (currentCompanyId !== '') {
            headers = headers.set('companyId', currentCompanyId);
            headers = headers.set('companyRevisionId', currentCompanyRevisionId);
        }

        return headers;
    }
}
